import * as React from 'react';
import ReactDOM from 'react-dom';

import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';

export const AI_RESTRICTED_MODAL_COPY = {
  nyc: {
    title: "Reading for Evidence activities can't be assigned",
    paragraphs: [
      "The NYCPS 2026-2027 AI Guidance restricts usage of Generative AI before Grade 9. Quill's Reading for Evidence tool uses Generative AI (with a series of robust guardrails) to generate feedback for students. As a result, the Reading for Evidence activities are not within the Guided Use policy.",
      "Quill's other tools (Connect, Diagnostic, Grammar, etc.) are compliant with the Guided Use policy and may continue to be used. To continue, please first go back and remove Reading for Evidence activities from your activity pack."
    ]
  }
};

interface EvidenceRestrictedModalProps {
  aiRestrictedGroup: string;
  onClose: () => void;
}

const EvidenceRestrictedModal: React.FC<EvidenceRestrictedModalProps> = ({ aiRestrictedGroup, onClose }) => {
  const { modalRef } = useModalAccessibility(onClose);
  const copy = AI_RESTRICTED_MODAL_COPY[aiRestrictedGroup] || AI_RESTRICTED_MODAL_COPY.nyc;

  return ReactDOM.createPortal(
    <div className="modal-container evidence-restricted-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="evidenceRestrictedModalTitle"
        aria-modal="true"
        className="evidence-restricted-modal quill-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="evidence-restricted-modal-header">
          <h3 className="title" id="evidenceRestrictedModalTitle">{copy.title}</h3>
        </div>
        <div className="evidence-restricted-modal-body modal-body">
          {copy.paragraphs.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
          <p>Please contact our support team at <a href="mailto:support@quill.org">support@quill.org</a> or via the Chat widget if you believe this is in error.</p>
        </div>
        <div className="evidence-restricted-modal-footer">
          <div className="buttons">
            <button
              className="quill-button contained medium green focus-on-light"
              onClick={onClose}
              type="button"
            >
              Go back
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default EvidenceRestrictedModal;
